import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generarPDFVenta = (datosVenta) => {
    const doc = new jsPDF();
    const { venta_id, usuario, detalles, cliente ,total } = datosVenta;
    const fecha = new Date().toLocaleString();

    // --- AQUÍ ESTÁ LA SOLUCIÓN: Definir centerX ---
    const pageWidth = doc.internal.pageSize.getWidth(); 
    const centerX = pageWidth / 2; 
    // ----------------------------------------------

    // Configuración de encabezado centrado
    doc.setFontSize(22);
    doc.setTextColor(40);
    doc.setFont("helvetica", "bold");
    doc.text("NOVATECH", centerX, 20, { align: 'center' }); 

    doc.setFontSize(14);
    doc.setFont("helvetica", "normal");
    doc.text("RUC: 10713591390", centerX, 28, { align: 'center' });
    doc.text("CEL: 906 145 083", centerX, 33, { align: 'center' });  

    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("TICKET DE VENTA", centerX, 42, { align: 'center' }); 

    doc.setFontSize(14);
    doc.setFont("helvetica", "normal");
    doc.text(`N° NV00${venta_id}`, centerX, 48, { align: 'center' }); 


    // Información adicional (Vendedor y Fecha)
    doc.setFontSize(11);
    doc.text(`Vendedor: ${usuario}`, 14, 60);
    doc.text(`Fecha: ${fecha}`, 14, 65);
    doc.text(`Cliente: ${cliente}`, 14, 70); // Se queda en 70
    // Tabla de productos
    const tableColumn = ["Producto", "Precio Unit.", "Cant.", "Subtotal"];
    const tableRows = detalles.map(item => [
        item.nombre || `ID: ${item.articulo_id}`,
        `S/ ${item.precio_venta.toFixed(2)}`,
        item.cantidad,
        `S/ ${item.subtotal.toFixed(2)}`
    ]);

    autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 75, // Bajamos el inicio para que no choque con el header
        theme: 'striped',
        headStyles: { fillColor: [44, 62, 80] },
    });

    // Total y Pie de página
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(`TOTAL A PAGAR: S/ ${total.toFixed(2)}`, 196, finalY, { align: 'right' });

    doc.setFontSize(9);
    doc.setFont("helvetica", "italic");
    doc.text("Gracias por su preferencia en Novatech", centerX, finalY + 20, { align: 'center' });

    // Abrir en pestaña nueva para imprimir
    // --- SOLUCIÓN UNIVERSAL (PC, ANDROID E IPHONE) ---
    
    // 1. Detectar si es un dispositivo iOS (iPhone, iPad, iPod)
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isIOS) {
        // En iPhone, window.open con Blobs falla. doc.save es la única forma 100% segura.
        // El iPhone guardará el archivo y lo abrirá en su visor nativo.
        doc.save(`ticket_${venta_id || 'cotizacion'}.pdf`);
    } else {
        // En PC y Android, seguimos con tu método original de abrir pestaña nueva
        const blob = doc.output('blob');
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        
        // Opcional: Liberar memoria después de un tiempo
        setTimeout(() => URL.revokeObjectURL(url), 100);
    }
};



export const generarTicketVenta = (datosVenta) => {
    const { venta_id, usuario, detalles, cliente, total } = datosVenta;
    
    // 1. Configuración del tamaño del ticket (80mm de ancho)
    const ticketWidth = 80; 
    const dynamicHeight = 100 + (detalles.length * 10); 
    const doc = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: [ticketWidth, dynamicHeight]
    });

    const centerX = ticketWidth / 2;
    const fecha = new Date().toLocaleString('es-PE');

    // 2. Encabezado Estilo Ticket
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("NOVATECH", centerX, 10, { align: 'center' }); 

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("RUC: 10713591390", centerX, 15, { align: 'center' });
    doc.text("LIMA - LIMA - COMAS", centerX, 19, { align: 'center' });
    doc.text("CEL: 906 145 083", centerX, 23, { align: 'center' });   

    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.text("TICKET DE VENTA", centerX, 30, { align: 'center' }); 
    doc.text(`N° NV00${venta_id}`, centerX, 35, { align: 'center' }); 

    // 3. Información de la venta
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(`Fecha: ${fecha}`, 5, 42);
    doc.text(`Vendedor: ${usuario}`, 5, 46);
    doc.text(`Cliente: ${cliente}`, 5, 50);

    // 4. Tabla de productos
    const tableColumn = ["Producto", "Cant.", "P. Unit", "Subt."]; 

    const tableRows = detalles.map(item => [
        item.nombre || `ID: ${item.articulo_id}`,
        item.cantidad,
        `S/${item.precio_venta.toFixed(2)}`,
        `S/${item.subtotal.toFixed(2)}`
    ]);

    autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 56,
        theme: 'plain',
        styles: { 
            fontSize: 7, 
            cellPadding: 0.5 
        },
        columnStyles: {
            0: { cellWidth: 33 }, 
            1: { cellWidth: 10, halign: 'center' },
            2: { cellWidth: 16, halign: 'right' },
            3: { cellWidth: 16, halign: 'right' }
        },
        margin: { left: 5, right: 5 }
    });

    // 5. Total y Pie (Usando el finalY de la tabla anterior)
    const finalY = doc.lastAutoTable.finalY + 5;
    doc.text("-".repeat(45), centerX, finalY, { align: 'center' });
    
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(`TOTAL: S/ ${total.toFixed(2)}`, 75, finalY + 7, { align: 'right' });

    doc.setFontSize(8);
    doc.setFont("helvetica", "italic");
    doc.text("¡Gracias por su compra!", centerX, finalY + 15, { align: 'center' });


    // 6. Lógica de impresión
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isIOS) {
        doc.save(`ticket_${venta_id}.pdf`);
    } else {
        const blob = doc.output('blob');
        const url = URL.createObjectURL(blob);
        const win = window.open(url, '_blank');
        if (win) {
            win.onload = () => {
                win.print();
                // Opcional: URL.revokeObjectURL(url);
            };
        }
    }
};



export const generarPDFCotizacion = (datosVenta) => {
    const doc = new jsPDF(); // Por defecto es A4
    const { venta_id, usuario, detalles, total } = datosVenta;
    const fecha = new Date().toLocaleString('es-PE');

    const pageWidth = doc.internal.pageSize.getWidth(); 
    const centerX = pageWidth / 2; 

    // 1. Encabezado centrado
    doc.setFontSize(22);
    doc.setTextColor(40);
    doc.setFont("helvetica", "bold");
    doc.text("NOVATECH", centerX, 20, { align: 'center' }); 

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text("RUC: 10713591390", centerX, 28, { align: 'center' });
    doc.text("CEL: 906 145 083", centerX, 33, { align: 'center' });  

    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("COTIZACIÓN", centerX, 45, { align: 'center' }); 

    // 2. Información adicional
    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    doc.text(`Vendedor: ${usuario}`, 14, 60);
    doc.text(`Fecha: ${fecha}`, 14, 66);

    // 3. Tabla de productos (SOLUCIÓN AL ERROR: Definimos tableColumn aquí)
    const tableColumn = ["Producto", "Cant.", "Precio Unit.", "Subtotal"];
    
    const tableRows = detalles.map(item => [
        item.nombre || `ID: ${item.articulo_id}`,
        item.cantidad,
        `S/ ${item.precio_venta.toFixed(2)}`,
        `S/ ${item.subtotal.toFixed(2)}`
    ]);

    autoTable(doc, {
        head: [tableColumn], // Ahora tableColumn existe en este contexto
        body: tableRows,
        startY: 75,
        theme: 'striped',
        headStyles: { fillColor: [44, 62, 80], halign: 'center' },
        styles: { fontSize: 10 },
        columnStyles: {
            0: { cellWidth: 'auto' }, // El nombre ocupa el resto
            1: { cellWidth: 25, halign: 'center' },
            2: { cellWidth: 35, halign: 'right' },
            3: { cellWidth: 35, halign: 'right' }
        }
    });

    // 4. Total y Pie de página
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    // 196 es cerca del borde derecho de un A4
    doc.text(`TOTAL: S/ ${total.toFixed(2)}`, 196, finalY, { align: 'right' });

    doc.setFontSize(10);
    doc.setFont("helvetica", "italic");
    doc.text("Esta cotización es válida por 7 días.", centerX, finalY + 20, { align: 'center' });
    doc.text("Lo esperamos...", centerX, finalY + 26, { align: 'center' });

    // 5. Lógica de guardado/apertura
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isIOS) {
        doc.save(`cotizacion_${venta_id || 'new'}.pdf`);
    } else {
        const blob = doc.output('blob');
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 100);
    }
};